<ng-container *transloco="let t">
  <svg-icon src="/assets/shared/icons/refresh-open-arrow.svg"></svg-icon>
  <h2 class="title">{{ t('ui.A new version of productName is available!', { productName }) }}</h2>
  <p class="instructions">{{ t('ui.Refresh this page for the latest and greatest version.') }}</p>
  <a [href]="appUrl" class="button button-pill button-reverse button-refresh">{{ t('ui.Refresh') }}</a>
</ng-container>
